import { h, FunctionComponent } from 'preact';
import { useDispatch } from 'react-redux';
import { SelectGroupProps } from '../types/forms';
import Label from './Label';
import SelectInput from './SelectInput';

/**
 * Generic select element with label & optional error messaging
 */
const SelectGroup: FunctionComponent<SelectGroupProps> = props => {
  const { input, id, state, options, reduxActions, onChangePost } = props;
  const dispatch = useDispatch();

  const onChangeHandler = (e: any) => {
    dispatch(
      reduxActions.updateInputValue({
        name: id,
        value: e.target.value,
      }),
    );

    if (onChangePost) onChangePost(e);
  };

  const selectProps = {
    ...input,
    id,
    onChangeHandler,
    className: 'form-control',
    isDisabled: state.isDisabled,
  };

  return state.isVisible !== false ? (
    <div
      id={`group-${id}`}
      className={`form-group ${
        state.isValid !== null && !state.isValid ? 'has-error' : ''
      }`}
    >
      <Label
        label={input.label}
        id={id}
        isValid={state.isValid}
        errorMessage={state.errorMessage}
        showRequiredIcon={input.showRequiredIcon}
      />
      <SelectInput options={options} {...selectProps} value={state.value} />
    </div>
  ) : null;
};

export default SelectGroup;
